module.exports = __webpack_public_path__ + "img/notice-icon.59f21d06.png";